import { render, staticRenderFns } from "./AddItem2List.vue?vue&type=template&id=258ac68e&scoped=true&"
import script from "./AddItem2List.vue?vue&type=script&lang=js&"
export * from "./AddItem2List.vue?vue&type=script&lang=js&"
import style0 from "./AddItem2List.vue?vue&type=style&index=0&id=258ac68e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258ac68e",
  null
  
)

export default component.exports